export default __webpack_public_path__ + "static/media/profile1.1ce1e7ba.jpg";